import { Group } from '@mantine/core'
import React from 'react'

import ColiCount from './ColiCount'
import FreightTerm from './FreightTerm'
import RoutingInformation from './RoutingInformation'
import { Servicelevel } from './Servicelevel'
import TotalVolume from './TotalVolume'
import TotalWeight from './TotalWeight'
import ValueOfGoods from './ValueOfGoods'

type TOverviewProps = {
  readonly?: boolean
  disableColiCountChange?: boolean
  // showServicelevel?: boolean
  // servicelevels?: TDataServicelevels
  showRoutingInformation?: boolean
  freightTermOptional?: boolean
  totalWeightTooltip?: string
  showServicelevel?: boolean
}

const Overview = (props: TOverviewProps): React.ReactElement => {
  const {
    readonly,
    disableColiCountChange,
    showRoutingInformation,
    freightTermOptional,
    totalWeightTooltip,
    showServicelevel,
  } = props

  return (
    <div>
      <Group spacing="xl" style={{ alignItems: 'start' }}>
        {showServicelevel && <Servicelevel />}
        <ColiCount readonly={readonly} disable={disableColiCountChange} />
        <TotalWeight readonly={readonly} tooltip={totalWeightTooltip} />
        <TotalVolume readonly={readonly} />
        <FreightTerm readonly={readonly} isOptional={freightTermOptional} />
        <ValueOfGoods readonly={readonly} />
        {showRoutingInformation && <RoutingInformation readonly={readonly} />}
        {/* TODO: custom order service fields hier (nicht aktivierbare, spezial services wie warenwert/proforma, frankatur) */}
      </Group>
    </div>
  )
}

export default Overview
